module.exports = __webpack_public_path__ + "img/华润@2x.0a328f0b.png";